const Avatar = ({img}) => {
  return <img src={img} className="h-16 w-16 rounded-full"></img>;
};

export { Avatar };
